export const placeholderText = {
    inputNameText: "Username",
    inputEmailText: "Email",
    inputPasswordText: "Password",
    inputConfirmPasswordText: "Confirm password",
}